import React, { useEffect, useContext, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { SetSubMData, GetSubMData, GetSubscriptionEdit, ResetSubscriptionEdit } from '../../store/subscriptionAtom';
import { subscriptionService } from '../../services/subscription.service';
import underscore from 'underscore';
import { useForm, useFormState } from 'react-hook-form';
import LogicContext from '../../Context/LogicContext';
import AddSubscriptionAdminSelect from './AddSubscriptionAdminSelect';
import SubscriptionGiftSelect from './SubscritionGiftSelect';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import { GetEditSalesOrder, ResetEditSalesOrder } from '../../store/salesOrderAtom';
import moment from 'moment';
import AddSubscriptionTable from './AddSubscriptionTable';
import AddSubProduct from './AddsubProduct';
import AddSubSelectItem from './AddSubSelectItem';
import GiftBeneficiary from './GiftBeneficiary';
import GeneralCustomerSearch from '../../generals/GeneralCustomerSearch';
import AddSubCoupon from './AddSubCoupon';
import AddSubCustomer from './AddSubCustomer';
import AddSubtypeSelect from './AddSubtypeSelect';

const AddSubscriptionPage = () => {
  const resetSalesOrderEdit = ResetEditSalesOrder();
  const getSubscriptionEdit = GetSubscriptionEdit();
  const resetSubscriptionEdit = ResetSubscriptionEdit();
  const myPromiseModal = createModal(GeneralModal);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const { dirtyFields } = useFormState({ control });
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const logicContext = useContext(LogicContext);
  const [productFeature, setProductFeature] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [productPlanList, setProductPlanList] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({});
  const [couponValue, setCouponValue] = useState(0);
  const [isAGift, setIsAGift] = useState(null);

  // ==== NEW STATE FOR BRONZE PLANS ====

  const [bronzeRecur, setBronzeRecur] = useState(true);
  const [subscriptionMonthsCycle, setSubscriptionsMonthCycle] = useState(1);

  const external_Customer_Id = searchParams.get('Customer_Id');
  const Customer_Full_Name = searchParams.get('Customer_Full_Name');
  const discountAmount = watch('discount_amount', 0);

  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = 'Add Subscription';
    setValue('Gift_Id', 2);
    setValue('Email_Send_Allow_Id', 2);

    if (external_Customer_Id) {
      setValue('Customer_Id', external_Customer_Id);
    }

    if (getSubscriptionEdit?.details?.subscription_ref_no) {
      setProductPlanList(
        getSubscriptionEdit?.itemList.map(item => ({
          Item_Name: item?.product_feature_name,
          Quantity: item?.quantity,
          Rate: item.rate,
          Billing_Cycle: item?.recuring_cycle,
          Item_Sku: item?.item_sku,
          tax_id: item?.tax_id,
          Item_Id: item?.item_id,
        }))
      );
      setValue('Gift_Id', getSubscriptionEdit.details?.gift_id);
      setValue('subscription_ref_no', getSubscriptionEdit?.details?.subscription_ref_no);
      setSelectedCustomer({
        Name: getSubscriptionEdit?.details?.customer_full_name,
        Customer_Id: getSubscriptionEdit?.details?.customer_id,
      });
      setValue('Customer_Id', getSubscriptionEdit?.details?.customer_id);
      setValue('coupon_code', getSubscriptionEdit?.details?.coupon_code);
      setValue('discount_amount', getSubscriptionEdit?.details?.discount_amount);

      if (getSubscriptionEdit.details?.gift_id === 1) {
        setValue('gift_recipient_ref_no', getSubscriptionEdit?.details?.gift_recipient_ref_no);
      }
      if (getSubscriptionEdit?.details?.discount_value > 0) {
        setCouponValue(getSubscriptionEdit?.details?.discount_value);
      }
      setValue('Email_Send_Allow_Id', getSubscriptionEdit?.details?.email_send_allow_id);
    }

    return () => {
      resetSubscriptionEdit();
      resetSalesOrderEdit();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (external_Customer_Id) {
      subscriptionService.getCustomer(external_Customer_Id).then(res => {
        if (res?.data) {
          setSelectedCustomer(res.data);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------------------------------------------------------------
  // Handlers (unchanged)
  // ------------------------------------------------------------------
  const onCustomerSelect =  async(customer) => {
    setValue('Customer_Id', customer.Customer_Id);
    setSelectedCustomer(customer);
    try {
     const response =  await subscriptionService.getSubscriptionAddress(customer.Customer_Id);
     if (response.data?.customer_info?.length) {
       setCustomerDetails(response?.data?.customer_info[0]);
     }
      
    } catch (error) {
      
    }
  }

  function onEmailSendChecked(val) {
    setValue('Email_Send_Allow_Id', val);
  }

  const onSubmit = async () => {
    const formValues = getValues();
    const uniqList = underscore.uniq(productPlanList, false, item => item?.Item_Id);

    if (!formValues?.Customer_Id) {
      return logicContext.showToast('Please select a customer!', 'error');
    }
    if (!productPlanList?.length) {
      return logicContext.showToast('At least one item must be selected!', 'error');
    }

    await myPromiseModal({
      title: 'Confirmation',
      body: getSubscriptionEdit?.details?.subscription_ref_no ? 'Update subscription' : 'Do you want to save this record?',
      showInput: false,
    }).then(res => {
      if (res.decision) {
        if (productPlanList?.length !== uniqList.length) {
          return logicContext.showToast('Multiple Product selection, Product must be unique!', 'error');
        }

        const xml_plan_complete = `<root>${productPlanList
          .map(
            productItem => `<a>
              <item_sku>${productItem?.Item_Sku}</item_sku>
              <price>${productItem?.Rate || 0}</price>
              <quantity>${productItem?.Quantity || 0}</quantity>
              <tax_id>${productItem?.tax_id || 0}</tax_id>
              <billing_cycles>${productItem?.Billing_Cycle}</billing_cycles>
            </a>`
          )
          .join('')}</root>`;

        subscriptionService.submitSubscription({
            ...formValues,
            option: getSubscriptionEdit?.details?.subscription_ref_no ? 2 : 1,
            recuring_id:bronzeRecur ? 1 : 2,
            recuring_cycle_number:subscriptionMonthsCycle,
            xml_string_plan: xml_plan_complete,
          })
          .then(res => {
              if (res?.data !== undefined) {
                const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
                const { message_id, message_text } = cleanResponse;

                if (message_id == 1) {
                  logicContext.showToast(message_text, 'success');
                  navigate(-1);
                  sessionStorage.setItem('reloadPage', 'true');
                }
              }
          })
          .catch(err => {
            // logicContext.showToast('Form submission failed!', 'error');
          });
      }
    });
  };

  function onErrors(error) {
    logicContext.showToast('Form error', 'error');
  }

  function onGiftChecked(val) {
    setIsAGift(val);
    setValue('Gift_Id', val);
  }

  function onGiftPersonSelect(giftPerson) {
    setValue('gift_recipient_ref_no', giftPerson?.Recipient_Ref_No);
  }

  function onAddonQuantityChange(value, index) {
    const newQuantity = value;
    if (newQuantity > 0) {
      const newList = productPlanList?.map((item, i) => {
        if (i === index) {
          return { ...item, Quantity: parseFloat(newQuantity) };
        }
        return item;
      });
      setProductPlanList([...newList]);
    }
  }
  function onRateChange(value, index) {
    const newRate = value;
    if (newRate > 0) {
      const newList = productPlanList?.map((item, i) => {
        if (i === index) {
          return { ...item, Rate: parseFloat(newRate) };
        }
        return item;
      });
      setProductPlanList([...newList]);
    }
  }

  function removeOldAddon(index) {
    const newList = [...productPlanList];
    if (newList[index]) {
      newList.splice(index, 1);
      setProductPlanList([...newList]);
    }
  }

  function onAddonTaxSelect(val, index) {
    const newList = [...productPlanList];
    newList[index]['tax_id'] = parseInt(val?.Tax_Id);
    setProductPlanList([...newList]);
  }



  function onCouponSelect(val) {
    setValue('coupon_code', val.Discount_Coupon_Code);
    setValue('discount_amount', val.Discount_Value);
    setCouponValue(val?.Discount_Value);
  }

  function onPlanFeatureSelect(feature) {
    if (productPlanList?.length){
      return logicContext.showToast('You have to empty selected item before you can change product!', 'info');
    } 
    setProductFeature(feature);
  }

  const onItemSelect = selItem => {
    const firstItem = productPlanList[0];
    if (firstItem?.Item_Id && firstItem?.Product_Feature_Id !== selItem?.Product_Feature_Id) {
      return logicContext.showToast('Multiple basket type is not allowed!', 'error');
    }
    const alreadyExistItem = productPlanList.find(item => item.Item_Id === selItem?.Item_Id );
    if (alreadyExistItem) {
      return logicContext.showToast('The selected item has been selected previously!', 'error');
    }
    setProductPlanList(prev => [
      ...prev,
      {
        ...selItem,
        label: selItem.Item_Name,
        Sales_Rate: selItem?.Sales_Rate,
        Quantity: 1,
        tax_id: 0,
        Billing_Cycle: 1,
      },
    ]);
  };

  const onBillingCycleChange = (cycle, index) => {
    if (cycle > 0) {
      const newList = productPlanList.map((item, i) => {
        if (i === index) {
          return { ...item, Billing_Cycle: parseInt(cycle) };
        }
        return item;
      });
      setProductPlanList([...newList]);
    }
  };

  function activationDate() {
    let defaultDate = moment(Date.now()).format('YYYY-MM-DD');
    if (getSubscriptionEdit?.details?.subscription_activated_date_string) {
      defaultDate = moment(getSubscriptionEdit?.details?.subscription_activated_date_string).format('YYYY-MM-DD');
    }
    return (
      <div>
        <input
          defaultValue={defaultDate}
          className="w-full px-3 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
          type="date"
          {...register('Subscription_Activated_Date', {
            required: 'Activation date is required',
          })}
        />
        {errors?.Subscription_Activated_Date && <p className="mt-1 text-xs text-red-500">{errors.Subscription_Activated_Date.message}</p>}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">
          {getSubscriptionEdit?.details?.subscription_ref_no ? 'Edit Subscription' : 'Add Subscription'}
        </h1>
        <form onSubmit={handleSubmit(onSubmit, onErrors)}>
          {/* Customer & Activation Date */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Customer <span className="text-red-500">*</span>
                </label>
                <GeneralCustomerSearch defaultVal={selectedCustomer?.customer_full_name} onCustomerSelect={onCustomerSelect} />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Activation Date <span className="text-red-500">*</span>
                </label>
                {activationDate()}
              </div>
            </div>
          </section>

          {/* Customer Information */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <p className="text-sm font-semibold text-gray-700 mb-3">Customer Information</p>
                {selectedCustomer && (
                  <div className="mt-2 text-sm text-gray-700">
                    <p className="font-semibold">Customer: {selectedCustomer?.Name || Customer_Full_Name}</p>
                    <p className="font-semibold">ID: {selectedCustomer?.Customer_Id || external_Customer_Id}</p>
                  </div>
                )}
                <div className="space-y-2 text-sm text-gray-700">
                  <p className="font-semibold mt-2">Shipping Address</p>
                  <p>{customerDetails?.full_address_shipping || getSubscriptionEdit?.details?.shipping_address1}</p>
                  <p className="font-semibold mt-2">
                    Email to <span className="text-red-500 text-xs">(Email will be sent to customer)</span>
                  </p>
                  <AddSubtypeSelect
                    onEmailSendSelect={onEmailSendChecked}
                    val={getSubscriptionEdit?.details?.email_send_allow_id}
                    email={selectedCustomer?.Customer_Email_Address || getSubscriptionEdit?.details?.customer_email_address}
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Subscription Gift */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <label className="text-sm font-medium text-gray-700 mb-3">
              Is this a gift? <span className="text-red-500 text-xs">(Select YES if applicable)</span>
            </label>
            <div className="max-w-md">
              <SubscriptionGiftSelect val={getSubscriptionEdit.details?.gift_id} onGiftChecked={onGiftChecked} />
              {isAGift === 1 && (
                <GiftBeneficiary
                  isAGift={isAGift}
                  Customer_Id={selectedCustomer?.Customer_Id || getSubscriptionEdit?.customer_id}
                  onGiftPersonSelect={onGiftPersonSelect}
                />
              )}
            </div>
          </section>

          <section className="mb-8 p-6 bg-white rounded-lg border border-gray-200">
            <div className="flex flex-wrap items-end gap-8 max-w-4xl">
              {/* Recur Monthly */}
              <div className="flex-1 min-w-[260px]">
                <label className="block text-sm font-medium text-gray-900 mb-3">Do you want your plan to recur monthly?</label>
                <div className="relative">
                  <select
                    value={bronzeRecur ? 'Yes' : 'No'}
                    onChange={e => setBronzeRecur(e.target.value === 'Yes')}
                    className="block w-full px-4 py-3 pr-10 text-base text-gray-900 bg-white border border-green-500 rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500"
                  >
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>

                {bronzeRecur && (
                  <div className="mt-3 flex items-center">
                    <input
                      type="checkbox"
                      checked
                      readOnly
                      className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500"
                    />
                    <label className="ml-2 text-sm text-gray-700">Recur every month until I cancel</label>
                  </div>
                )}
              </div>

              {/* Number of Months */}
              {bronzeRecur && (
                <div className="flex-1 min-w-[220px]">
                  <label className="block text-sm font-medium text-gray-900 mb-3">Number of months</label>
                  <div className="flex items-center justify-center w-48 h-12 border border-gray-300 rounded-lg bg-white">
                    <button
                      type="button"
                      onClick={() => setSubscriptionsMonthCycle(Math.max(1, subscriptionMonthsCycle - 1))}
                      className="w-12 h-full text-xl font-semibold text-gray-600 hover:bg-gray-100 rounded-l-lg focus:outline-none"
                    >
                      −
                    </button>
                    <span className="w-20 text-center text-lg font-medium text-gray-900">{subscriptionMonthsCycle}</span>
                    <button
                      type="button"
                      onClick={() => setSubscriptionsMonthCycle(subscriptionMonthsCycle + 1)}
                      className="w-12 h-full text-xl font-semibold text-gray-600 hover:bg-gray-100 rounded-r-lg focus:outline-none"
                    >
                      +
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* Product & Item Selection */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Product <span className="text-red-500 text-xs">(Select product)</span>
                </label>
                <AddSubProduct defaultVal={{ label: getSubscriptionEdit?.plan?.Product_Name }} onProductSelect={onPlanFeatureSelect} />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Item <span className="text-red-500 text-xs">(Select product before choosing item)</span>
                </label>
                <AddSubSelectItem onItemSelect={onItemSelect} productFeature={productFeature} />
              </div>
            </div>
          </section>

          {/* Discount Fields */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">Select Coupon</label>
                <AddSubCoupon defaultVal={{ label: getSubscriptionEdit?.details?.discount_description }} onCouponSelect={onCouponSelect} />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 mb-1">Discount Amount</label>
                <input
                  className="w-full px-3 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                  type="number"
                  {...register('discount_amount')}
                />
              </div>
            </div>
          </section>

          {/* Product Table */}
          <section className="mb-6 p-4 sm:p-6 bg-white rounded-md border border-gray-200">
            <p className="text-sm font-medium text-gray-700 mb-3">
              Product Table <span className="text-red-500 text-xs">(Selected item details)</span>
            </p>
            <AddSubscriptionTable
              onAddonTaxSelect={onAddonTaxSelect}
              onAddonQuantityChange={onAddonQuantityChange}
              onRateChange={onRateChange}
              productPlanList={productPlanList}
              discountAmount={discountAmount}
              removeOldAddon={removeOldAddon}
              onBillingCycleChange={onBillingCycleChange}
            />
          </section>

     

          {/* Buttons */}
          <section className="flex justify-between items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition text-sm font-medium"
            >
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition text-sm font-medium">
              Save and Create Subscription
            </button>
          </section>
        </form>
      </div>
    </div>
  );
};

export default AddSubscriptionPage;



